import { render } from "./RemainFee.vue?vue&type=template&id=db70a50e&scoped=true"
import script from "./RemainFee.vue?vue&type=script&lang=js"
export * from "./RemainFee.vue?vue&type=script&lang=js"

import "./RemainFee.vue?vue&type=style&index=0&id=db70a50e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db70a50e"]])

export default __exports__